export default __webpack_public_path__ + "static/media/Paris-Grey.361e1e0d.jpg";